import React from 'react';
import { useTranslationWithNamespace } from '@gov-nx/core/service';
import type { PageCode } from '@gov-nx/module/page';
import { useSpravaSouhlasuDetailContext } from '@gov-nx/module/page';
import { Button, ButtonGroupLayout, Icon } from '@gov-nx/ui/web';

interface ConsentManagementInfoProps {
	code: PageCode;
}

export const ConsentManagementInfo = ({ code }: ConsentManagementInfoProps) => {
	const { controls, filteredDetail, setControls, handleDownload } =
		useSpravaSouhlasuDetailContext();
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const tsn = getLocalizeCurried(code);

	return (
		<div className="flex flex-col [ md:flex-row md:justify-between md:items-center ]">
			<span className="pb-(--templates-margin-3xl) text-body-xl [ md:pb-0 ]">
				{tsn('pole.udaje.id-souhlasu')}: <strong>{filteredDetail?.id}</strong>
			</span>
			<ButtonGroupLayout customClasses="flex-col! [ md:flex-row! ]">
				<Button
					onClick={() => handleDownload()}
					color="primary"
					type="outlined"
					nativeType="button"
					isLoading={controls.processLoading}
					isDisabled={controls.downloadLoading}
					size="l"
					isExpandedMobile
					aria-label={tsn('tlacitko.akce.stahnout')}
					iconStart={
						<Icon
							name="download"
							type="templates"
						/>
					}>
					{tsn('tlacitko.akce.stahnout')}
				</Button>
				<Button
					onClick={() => setControls({ displayModal: true })}
					color="error"
					type="outlined"
					nativeType="button"
					size="l"
					isExpandedMobile
					aria-label={tsn('tlacitko.akce.odvolat-souhlas')}
					iconStart={
						<Icon
							name="x-lg"
							type="components"
						/>
					}>
					{tsn('tlacitko.akce.odvolat-souhlas')}
				</Button>
			</ButtonGroupLayout>
		</div>
	);
};
